import React, { Component } from "react";
import AdminRoute from "./components/AdminRoute";
import { Switch } from "react-router-dom";
import Reports from "./scenes/Reports/";
import Activities from "./scenes/Activities/";
import ActivityDetail from "./scenes/ActivityDetail/";
import ActivityCreate from "./scenes/ActivityCreate/";
import Users from "./scenes/Users/";
import UserDetail from "./scenes/UserDetail/";
import UserCreate from "./scenes/UserCreate/";


class Admin extends Component {

    render() {
        return (
            <Switch>
                <AdminRoute path={'/admin/users/create'} component={UserCreate} />
                <AdminRoute path={'/admin/users/:id'} component={UserDetail} />
                <AdminRoute path={'/admin/users'} component={Users}/>
                <AdminRoute path={'/admin/activities/create'} component={ActivityCreate}/>
                <AdminRoute path={'/admin/activities/:id'} component={ActivityDetail}/>
                <AdminRoute path={'/admin/activities'} component={Activities}/>
                <AdminRoute path={"/admin/reports"} component={Reports}/>
            </Switch>
        );
    }

}


export default Admin;



// WEBPACK FOOTER //
// ./src/scenes/Admin/index.js